export function exportToCSV(data, filename = 'export.csv', headers = null, numericKeys = []) {
  if (!data || data.length === 0) return;

  let headerRow, keys;
  if (headers && headers.length > 0) {
    headerRow = headers.map(h => `"${h.label}"`).join(',');
    keys = headers.map(h => h.key);
  } else {
    keys = Object.keys(data[0]);
    headerRow = keys.join(',');
  }

  const rows = data.map(row =>
    keys.map(key => {
      const value = row[key] ?? '';
      // Use ="value" format for numeric keys to preserve trailing zeros in Excel
      if (numericKeys.includes(key) && value !== '' && value !== 'N/A') {
        return `="${value}"`;
      }
      return `"${value}"`;
    }).join(',')
  );

  const csvContent = [headerRow, ...rows].join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}